<template>
  <div class="content">
    <div class="row">
      <div class="form-group">
        <label>Template:</label>
        <select v-model="template">
          <option v-for="t in templates" :key="t">{{ t }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <label>Sprache:</label>
        <select v-model="lang">
          <option value="de">deutsch</option>
          <option value="en">englisch</option>
          <option value="fr">französisch</option>
          <option value="nl">niederländisch</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import documents from '@/modules/documents.js'

export default {
    name: 'TemplateSelector',
    data() {
      return {
        templates: [],
        lang: 'de',
        template: false
      }
    },
    mounted: function() {
      var self = this;
      documents.templates(this,function(data) {
        self.templates = data;
      })
    }
}
</script>
